import OrderAndCustomerInfo from '@/components/OrdersModule/OrderDetail/Header/OrderAndCustomerInfo'
import ShortCodeAndDeliveryTypeCategoryAndChannelWithCountdownOrCompletionIndicator from '@/components/OrdersModule/OrderDetail/Header/ShortCodeAndDeliveryTypeCategoryAndChannelWithCountdownOrCompletionIndicator'
import { ColorEnum } from '@/constants/color'
import Cutout from '@/features/common/components/Cutout'
import { FC } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

interface OrderDetailHeaderProps {
    uuid: string
    style?: StyleProp<ViewStyle>
}

const OrderDetailHeader: FC<OrderDetailHeaderProps> = ({ uuid, style }) => {
    return (
        <View style={style}>
            <View style={styles.content}>
                <ShortCodeAndDeliveryTypeCategoryAndChannelWithCountdownOrCompletionIndicator
                    uuid={uuid}
                    style={styles.deliveryTypeAndChannelAndShortCodeWithCountdown}
                />
                <OrderAndCustomerInfo uuid={uuid} />
            </View>
            <Cutout />
        </View>
    )
}

const styles = StyleSheet.create({
    content: {
        backgroundColor: ColorEnum.GRAY_100,
        padding: 16,
    },
    deliveryTypeAndChannelAndShortCodeWithCountdown: {
        marginBottom: 16,
    },
})

export default OrderDetailHeader
